module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// D:/midea_porject/php/htdocs/~/babel-runtime/core-js/promise.js
// module id = 41
// module chunks = 0